export enum MEMBank {
  Reserved = 0,
  TID = 2,
  EPC = 1,
  USER = 3
}
export enum HFProtocol {
  HF_15693 = 1,
  HF_14443A = 2,
  HF_14443B = 3
}
export enum CardType_14443A {
  MifareOne_S50 = 0x04,
  MifareOne_S70 = 0x02,
  Mifare_UltraLight = 0x44
}
export class LockParam {
  LockMem: string;
  Password: string;
  LockMode: string;
  HexEpc: string;
  Address: number;
  BlockLength: number;
}
export class ReadParam {
  MemBank: MEMBank;
  Address: number;
  BlockLength: number;
  Password: string;
  HexEpc: string;
}
export class WriteParam extends ReadParam {
  HexWriteData: string;
}

export class HFInventoryParam {
  Protocol: HFProtocol;
  CardType_14443A: CardType_14443A;

}